// Gate post pricing from MAK_Preisliste_Vorlage.xlsx - Auto-generated

export const gatePostPricing = {
  '10x10': [
    { height: 56.0, price: 106.0 },
    { height: 66.0, price: 116.0 },
    { height: 76.0, price: 123.0 },
    { height: 86.0, price: 128.0 },
    { height: 96.0, price: 136.0 },
    { height: 106.0, price: 139.0 },
    { height: 116.0, price: 150.0 },
    { height: 126.0, price: 158.0 },
    { height: 136.0, price: 167.0 },
    { height: 146.0, price: 176.0 },
    { height: 156.0, price: 178.0 },
    { height: 166.0, price: 183.0 },
    { height: 176.0, price: 194.0 },
    { height: 186.0, price: 199.0 },
    { height: 196.0, price: 204.0 },
    { height: 206.0, price: 208.0 },
  ],
  '12x12': [
    { height: 56.0, price: 204.0 },
    { height: 66.0, price: 204.0 },
    { height: 76.0, price: 204.0 },
    { height: 86.0, price: 204.0 },
    { height: 96.0, price: 204.0 },
    { height: 106.0, price: 204.0 },
    { height: 116.0, price: 204.0 },
    { height: 126.0, price: 204.0 },
    { height: 136.0, price: 213.0 },
    { height: 146.0, price: 216.0 },
    { height: 156.0, price: 227.0 },
    { height: 166.0, price: 232.0 },
    { height: 176.0, price: 239.0 },
    { height: 186.0, price: 252.0 },
    { height: 196.0, price: 271.0 },
    { height: 206.0, price: 283.0 },
  ],
  '15x15': [
    { height: 56.0, price: 271.0 },
    { height: 66.0, price: 271.0 },
    { height: 76.0, price: 271.0 },
    { height: 86.0, price: 271.0 },
    { height: 96.0, price: 271.0 },
    { height: 106.0, price: 271.0 },
    { height: 116.0, price: 271.0 },
    { height: 126.0, price: 271.0 },
    { height: 136.0, price: 294.0 },
    { height: 146.0, price: 299.0 },
    { height: 156.0, price: 308.0 },
    { height: 166.0, price: 322.0 },
    { height: 176.0, price: 338.0 },
    { height: 186.0, price: 347.0 },
    { height: 196.0, price: 359.0 },
    { height: 206.0, price: 370.0 },
  ],
  '20x10': [
    { height: 56.0, price: 317.0 },
    { height: 66.0, price: 317.0 },
    { height: 76.0, price: 317.0 },
    { height: 86.0, price: 317.0 },
    { height: 96.0, price: 317.0 },
    { height: 106.0, price: 317.0 },
    { height: 116.0, price: 317.0 },
    { height: 126.0, price: 317.0 },
    { height: 136.0, price: 334.0 },
    { height: 146.0, price: 352.0 },
    { height: 156.0, price: 356.0 },
    { height: 166.0, price: 366.0 },
    { height: 176.0, price: 387.0 },
    { height: 186.0, price: 398.0 },
    { height: 196.0, price: 408.0 },
    { height: 206.0, price: 415.0 },
  ],
}

// Find nearest height price (ceiling approach)
const findNearestHeightPrice = (prices, targetHeight) => {
  const sorted = [...prices].sort((a, b) => a.height - b.height);
  for (const item of sorted) {
    if (item.height >= targetHeight) {
      return item;
    }
  }
  return sorted[sorted.length - 1];
};

export const getGatePostPrice = (postSize, gateHeight) => {
  const prices = gatePostPricing[postSize];
  if (!prices) return 0;
  
  // Gate post height typically = gate height + 30cm
  const postHeight = gateHeight + 30;
  const priceData = findNearestHeightPrice(prices, postHeight);
  return priceData ? priceData.price : 0;
};

export const getGatePostSizes = () => {
  return Object.keys(gatePostPricing).map(size => ({
    id: size,
    label: size.replace('x', ' × ') + ' cm'
  }));
};

// Export gatePostSizes as array for backward compatibility
export const gatePostSizes = [
  { id: 'none', label: 'ohne Steher' },
  ...Object.keys(gatePostPricing).map(size => ({
    id: size,
    label: size.replace('x', ' × ') + ' cm'
  }))
];
